import { MutationTree } from 'vuex';
import { EDirectoryMutation } from '@/content-library/directories/store/directory.constants';
import { IDirectoryState } from '@/content-library/directories/store/directory.types';
import { IDirectory } from '@/api/directories/types/directory';
import { IBreadcrumb } from '@/breadcrumbs/types/Breadcrumb';

export const mutations: MutationTree<IDirectoryState> = {
  [EDirectoryMutation.SetState](state: IDirectoryState, newState: IDirectoryState) {
    state.loaded = newState.loaded;
    state.loading = newState.loading;
    state.directories = newState.directories;
    state.breadcrumbs = newState.breadcrumbs;
  },
  [EDirectoryMutation.SetLoading](state: IDirectoryState, loading: boolean) {
    state.loading = loading;
  },
  [EDirectoryMutation.SetLoaded](state: IDirectoryState, loaded: boolean) {
    state.loaded = loaded;
  },
  [EDirectoryMutation.SetDirectories](state: IDirectoryState, directories: IDirectory[]) {
    state.directories = directories;
  },
  [EDirectoryMutation.SetBreadcrumbs](state: IDirectoryState, breadcrumbs: IBreadcrumb[]) {
    state.breadcrumbs = breadcrumbs;
  },
};
